module.exports = __webpack_public_path__ + "img/userB12.5512cb18.jpg";